import { Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { specialistRequests } from "api/specialistApi";
import { settings } from "app";
import React, { useCallback, useEffect, useState } from "react";
import {
  ArrayField,
  Datagrid,
  FunctionField,
  RecordContextProvider,
  SelectField,
  TextField,
  useRecordContext,
} from "react-admin";
import dataProvider from "server/dataProvider";
import SecuredComponent from "server/security/SecuredComponent";
import { CurriculumItemTypeChoices } from "utils/choices";
import AddCurriculaPrerequisitesDialog from "./Dialogs/AddCurriculaPrerequisitesDialog";
import permissions from "app/permissions";
import RemoveItemPrerequisiteDialog from "./Dialogs/RemoveItemPrerequisiteDialog";
import { useNotifyError } from "utils/useNotifyError";
import { SectionTitle } from "features/SectionTitle";

const PrerequisitesSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const notifyError = useNotifyError();
  const record = useRecordContext();
  const [prerequisites, setPrerequisites] = useState([]);

  const fetchCurriculaPrerequisites = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        specialistRequests.getCurriculaPrerequisites(record?.id),
        null,
        "GET",
      );
      setPrerequisites(data);
    } catch (err) {
      notifyError(err);
    }
  }, [record?.id, notifyError]);

  useEffect(() => {
    if (!record?.id) return;
    fetchCurriculaPrerequisites();
  }, [record?.id, fetchCurriculaPrerequisites]);

  return (
    <>
      <SectionTitle
        title="Предпоставки"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <RecordContextProvider value={{ prerequisites }}>
            <ArrayField
              source="prerequisites"
              label=""
            >
              <Datagrid
                bulkActionButtons={false}
                rowClick={false}
                sx={settings.style.secondaryLeftAlignedDatagrid}
              >
                <TextField
                  source="itemNameBg"
                  label="Тема"
                  sortable={false}
                />
                <SelectField
                  source="itemType"
                  label="Тип"
                  choices={CurriculumItemTypeChoices}
                  sortable={false}
                />
                <TextField
                  source="prerequisiteItemNameBg"
                  label="Предпоставка"
                  sortable={false}
                />
                <SelectField
                  source="prerequisiteItemType"
                  label="Тип на предпоставката"
                  choices={CurriculumItemTypeChoices}
                  sortable={false}
                />
                <FunctionField
                  render={rec => (
                    <SecuredComponent permission={permissions.canManageSpecializationsCurriculaItemsPrerequisites}>
                      <RemoveItemPrerequisiteDialog
                        curriculumId={record?.id}
                        fetchCurriculaPrerequisites={fetchCurriculaPrerequisites}
                        itemId={rec?.itemId}
                        prerequisiteItemId={rec?.prerequisiteItemId}
                      />
                    </SecuredComponent>
                  )}
                />
              </Datagrid>
            </ArrayField>
          </RecordContextProvider>
        </Grid>
        <SecuredComponent permission={permissions.canManageSpecializationsCurriculaItemsPrerequisites}>
          <AddCurriculaPrerequisitesDialog
            curriculumId={record?.id}
            fetchCurriculaPrerequisites={fetchCurriculaPrerequisites}
          />
        </SecuredComponent>
      </Grid>
    </>
  );
};

export default PrerequisitesSection;
